export default __webpack_public_path__ + "media/images/cta_blocks/send_thankyou_notes-4c5b99c284a145f5132e1196d56db336.jpg";